'use strict';

var _image = require('../Image/image');

var _image2 = _interopRequireDefault(_image);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PropTypes = require('prop-types');
var React = require('react');
var createReactClass = require('create-react-class');
var ADAHelpers = require('../../lib/ADAHelpers');

var LocalizationMixin = require('../../localization/CommonLocalizationMixin');

var YourNextRewardCard = createReactClass({
    displayName: 'YourNextRewardCard',
    mixins: [LocalizationMixin],

    propTypes: {
        nextReward: PropTypes.shape({
            image: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
            points: PropTypes.number.isRequired,
            rewardId: PropTypes.number.isRequired
        }),
        pointsNeeded: PropTypes.number.isRequired,
        handleChangeToNextReward: PropTypes.func.isRequired,
        isSignUpPage: PropTypes.bool
    },

    render: function render() {
        return React.createElement(
            'div',
            { id: 'item-and-change', className: 'item-and-change', onClick: this.props.handleChangeToNextReward,
                onKeyDown: ADAHelpers.keyupHandler, role: 'button', tabIndex: '0' },
            React.createElement(
                'div',
                { className: 'image-wrapper' },
                React.createElement(_image2.default, { src: this.props.nextReward.image,
                    backupImage: '/images/common/img_product_placeholder.png' })
            ),
            React.createElement(
                'div',
                { className: 'text-wrapper' },
                React.createElement(
                    'div',
                    { className: 'name' },
                    this.props.nextReward.name
                ),
                React.createElement(
                    'div',
                    { className: 'points' },
                    this.props.pointsNeeded + ' ' + (this.props.isSignUpPage ? this.getLocalizedText("rewards_points") : this.getLocalizedText("rewards_points_needed"))
                )
            ),
            React.createElement(
                'div',
                { className: 'change' },
                React.createElement(
                    'span',
                    null,
                    this.getLocalizedText("rewards_change").toUpperCase()
                )
            )
        );
    }
});

module.exports = YourNextRewardCard;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/loyalty/yourNextRewardCard.js
// module id = 315
// module chunks = 0